<app-advanced-filter-pop-up (applyFilter)="onClickAdvancedFilter()" (clearFilter)="clearFields()">
    <form class="theme-form">
        <div class="modal-body mx-2 py-0">
            <div class="row mx-0">
                <div class="col-12 px-0 gap-3 d-flex align-items-center mb-2">
                    <div class="col d-flex align-items-center gap-2">
                        <div class="w-100px  f-14 font-semibold text-gray-color text-nowrap mb-0">
                            Joining Date
                        </div>
                        <div class="col">
                            <app-range-datepicker #createdDatecomp [startDate]="advanceFilterRequest?.fromJoiningDate"
                                [endDate]="advanceFilterRequest?.toJoiningDate"
                                (startDateEmit)="advanceFilterRequest.fromJoiningDate = $event;"
                                (endDateEmit)="advanceFilterRequest.toJoiningDate = $event"></app-range-datepicker>
                        </div>
                    </div>
                    <div class="col d-flex  align-items-center">
                        <div class="w-100px  f-14 font-semibold text-gray-color text-nowrap mb-0 ">
                            Maturity Date
                        </div>
                        <div class="col">
                            <app-range-datepicker #invoiceDateComp [startDate]="advanceFilterRequest?.fromMaturityDate"
                                [endDate]="advanceFilterRequest?.toMaturityDate"
                                (startDateEmit)="advanceFilterRequest.fromMaturityDate = $event;"
                                (endDateEmit)="advanceFilterRequest.toMaturityDate = $event"></app-range-datepicker>
                        </div>
                    </div>
                </div>
                <div class="col-12 px-0 d-flex align-items-center mb-2 gap-2">
                    <div class="w-100px f-14 font-semibold text-gray-color text-nowrap mb-0">
                        Branch
                    </div>
                    <div class="col">
                    <app-custom-select2 
                        #branchDropdown   
                        [customId]="'branchDropdown'"
                        [whichDropdown]="storageName?.BRANCH_DROPDOWN"
                        (valueChanged)="advanceFilterRequest.branchId = $event">
                    </app-custom-select2>
                    </div>
                </div>
                <div class="col-12 px-0 d-flex align-items-center mb-2 gap-2">
                    <div class="w-100px f-14 font-semibold text-gray-color text-nowrap mb-0">
                        Scheme Name
                    </div>
                    <div class="col">
                        <app-ng-multi-select-dropdown 
                            [isShowlable]="false" 
                            [isPlusIcon]="false" 
                            [name]="'schemeid'"
                            [placeholder]="'Select Scheme Name'" 
                            [data]="data?.getAllDropdownModel?.schemeNameDropdown"
                            [id]="'schemeid'" 
                            [selectedIds]="selectedSchemeIds"
                            (onSelectItem)="advanceFilterRequest.selectedScheme= $event"
                            [isRequired]="false"
                            >
                        </app-ng-multi-select-dropdown>
                    </div>
                </div>
                <div class="col-12 px-0 d-flex align-items-center mb-2 gap-2">
                    <div class="w-100px f-14 font-semibold text-gray-color text-nowrap mb-0">
                        Redemption On
                    </div>
                    <div class="col">
                        <app-ng-multi-select-dropdown 
                            [isShowlable]="false" 
                            [isPlusIcon]="false"
                            [name]="'redemptiononId'" 
                            [id]="'redemptiononId'" 
                            [placeholder]="'Select Redemption'"
                            [data]="data.getAllDropdownModel?.redeemOnDropdown"
                            (onSelectItem)="advanceFilterRequest.selectedRedemption= $event"
                            [selectedIds]="selectedRedemptionIds" 
                            [isRequired]="false"
                            >
                        </app-ng-multi-select-dropdown>
                    </div>
                </div>
                <div class="col-12 px-0 d-flex align-items-center mb-2 gap-2">
                    <div class="w-100px f-14 font-semibold text-gray-color text-nowrap mb-0">
                        Duration Type
                    </div>
                    <div class="col">
                        <app-ng-multi-select-dropdown 
                            [isShowlable]="false" 
                            [isPlusIcon]="false"
                            [name]="'durationtypeId'" 
                            [id]="'durationtypeId'" 
                            [selectedIds]="selectedDurationTypeIds"
                            [isRequired]="false" 
                            [placeholder]="'Select Duration Type'"
                            [data]="data.getAllDropdownModel?.durationTypeDropdown"
                            (onSelectItem)="advanceFilterRequest.selecteddurationType = $event">
                        </app-ng-multi-select-dropdown>
                    </div>
                </div>
                <div class="col-12 px-0 d-flex align-items-center mb-2 gap-2">
                    <div class="w-100px f-14 font-semibold text-gray-color text-nowrap mb-0">
                        Installment Type
                    </div>
                    <div class="col">
                        <app-ng-multi-select-dropdown
                            [isShowlable]="false" 
                            [isPlusIcon]="false"
                            [name]="'installmwnttypeid'" 
                            [id]="'installmwnttypeid'"
                            [placeholder]="'Select Installment Type'" 
                            [selectedIds]="selectedInstallmentTypeIds"
                            [data]="data.getAllDropdownModel?.installmentTypeDropdown" 
                            (onSelectItem)="advanceFilterRequest.selectedinstallmentType = $event"
                            [isRequired]="false">
                        </app-ng-multi-select-dropdown>
                    </div>
                </div>
                <div class="col-12 px-0 d-flex align-items-center mb-2 gap-2">
                    <div class="w-100px f-14 font-semibold text-gray-color text-nowrap mb-0">
                        Saleperson
                    </div>
                    <div class="col">
                        <app-ng-multi-select-dropdown 
                            [isShowlable]="false" 
                            [isPlusIcon]="false" 
                            [name]="'fromuser'"
                            [id]="'fromuserId'" 
                            [selectedIds]="selectedSalepersonIds" 
                            [isRequired]="false"
                            [placeholder]="'Select SalePerson'" 
                            [data]="data.getAllDropdownModel?.salePersonDropdown"
                            (onSelectItem)="advanceFilterRequest.selectedSalePerson = $event">
                        </app-ng-multi-select-dropdown>
                    </div>
                </div>
                <div class="col-12 px-0 gap-3 d-flex align-items-center mb-2 ">
                    <div class="col d-flex align-items-center gap-2">
                        <div class="w-100px f-14 font-semibold text-gray-color text-nowrap mb-0">
                            Installment.Amt.
                        </div>
                        <div class="col">
                            <app-input 
                                [inputName]="'installmentAmount'" 
                                [inputType]="'text'"
                                [inputId]="'installmentAmount'" 
                                [isRequired]="false"
                                [inputValue]="advanceFilterRequest?.installmentAmount"
                                (inputValueEmit)="advanceFilterRequest.installmentAmount = $event">
                            </app-input>
                        </div>
                    </div>
                    <div class="col d-flex align-items-center">
                    </div>
                </div>
            </div>
        </div>
    </form>
</app-advanced-filter-pop-up>